export abstract class SharedUnlockFollowerService {
  abstract start(): Promise<void>;
}
